import { useScrollReveal } from "@/hooks/useScrollReveal";
import { useLang, translations } from "../i18n";

export function WalletSection() {
  const { lang } = useLang();
  const t = translations.wallet;
  const ref = useScrollReveal(80);

  return (
    <section className="bg-[var(--background)] py-20 md:py-28 lg:py-32 px-6 md:px-12 lg:px-20">
      <div ref={ref} className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <span className="reveal inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-[var(--primary)] px-3 py-1.5 bg-[var(--primary)]/8 border border-[var(--primary)]/15 rounded-full mb-4">
              {t.badge[lang]}
            </span>
            <h2 className="reveal text-3xl md:text-[40px] font-extrabold tracking-tight text-[var(--foreground)] leading-[1.15] mb-4">
              {t.heading1[lang]}
              <br />
              {t.heading2[lang]}
            </h2>
            <p className="reveal text-[15px] text-[var(--muted-foreground)] mb-8 max-w-md leading-relaxed">
              {t.description[lang]}
            </p>
            <div className="reveal flex flex-col gap-3">
              {t.bullets[lang].map((item) => (
                <div
                  key={item}
                  className="flex items-center gap-3 text-sm text-[var(--muted-foreground)]"
                >
                  <span className="w-1.5 h-1.5 rounded-full bg-[var(--primary)]" />
                  {item}
                </div>
              ))}
            </div>
          </div>

          <div className="reveal">
            <div className="bg-[var(--code-bg)] border border-[var(--border)] rounded-xl overflow-hidden shadow-xl">
              <div className="flex items-center justify-between px-5 py-4 bg-black/20 border-b border-white/[0.06]">
                <span className="font-mono text-[12px] font-medium text-white/50">
                  {t.mockup.label[lang]}
                </span>
                <span className="inline-flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-wider text-emerald-400">
                  <span className="w-1.5 h-1.5 rounded-full bg-emerald-400" />
                  {t.mockup.nonCustodial[lang]}
                </span>
              </div>
              <div className="p-6 space-y-5">
                <div>
                  <div className="text-[11px] text-white/30 uppercase tracking-wider font-semibold mb-1">
                    {t.mockup.balance[lang]}
                  </div>
                  <div className="text-2xl font-black text-white font-mono">
                    1.847 <span className="text-white/40 text-sm">BTC</span>
                  </div>
                  <div className="text-xs text-white/30 font-mono mt-0.5">
                    ≈ R$ 952,410.00
                  </div>
                </div>
                <div className="border-t border-white/[0.06] pt-4 space-y-3">
                  <div className="flex justify-between text-[13px]">
                    <span className="text-white/40">{t.mockup.todayRevenue[lang]}</span>
                    <span className="text-[var(--primary)] font-mono">+48,200 sats</span>
                  </div>
                  <div className="flex justify-between text-[13px]">
                    <span className="text-white/40">{t.mockup.txToday[lang]}</span>
                    <span className="text-white/70 font-mono">847</span>
                  </div>
                  <div className="flex justify-between text-[13px]">
                    <span className="text-white/40">{t.mockup.yourSpread[lang]}</span>
                    <span className="text-white/70 font-mono">1.5%</span>
                  </div>
                </div>
                <button className="w-full py-2.5 bg-white/[0.06] hover:bg-white/[0.1] border border-white/[0.08] rounded-lg text-[13px] font-semibold text-white/70 transition-colors cursor-default">
                  {t.mockup.withdraw[lang]}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
